<template>
<div id="PermitInvoiceView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
     <div class="web-right-sidebar"> <!--right sidebar-->
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab">
                <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Permit Details</a>
                    <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                </div>
                <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                        <div class="list-view">
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Invoice Type:</label>
                                <span class="col">{{invType}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Invoice#:</label>
                                <span class="col">{{invoice_number}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Customer:</label>
                                <span class="col">{{customer}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Invoice Date:</label>
                                <span class="col">{{invoice_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Due Date:</label>
                                <span class="col">{{dueDate}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Term:</label>
                                <span class="col">{{term}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">

                                <label class="col">Status:</label>
                                <span class="col">{{status}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Open Amount :</label>
                                <span class="col">{{open_amount}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Total :</label>
                                <span class="col">{{total_due}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Created Date:</label>
                                <span class="col">{{created_at}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                        <permit-activity-log-list :activityLogVal="activityLogsTabValue"></permit-activity-log-list>
                    </div>
                </div>
            </div>
        </div>
    </div> <!--right sidebar-->
    <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
        <div class="page-name asset-view-page-name purchase-order-title">
            <div class="page-title"> # {{invoice_number}}</div>
            <div class="web-action-btn btn-groups text-right">
                <button type="button" v-if="canAddCrm && deleted_at == null" class="btn btn-secondary" v-on:click="crmSection()" >
                    <i class="fp-agreement"> </i> {{crmBtnTitle}}
                </button>
                <template v-if="!isCrmSection">
                <button v-if="deleted_at == null" type="button" class="btn btn-secondary" v-on:click="previewInvoice()" >
                    <i class="fp-print"> </i> Print Or Preview
                </button>
                <button v-if="deleted_at == null" type="button" class="btn btn-secondary" v-on:click="downloadPdf()" >
                    <i class="fp-download"> </i> Download
                </button>
                <button v-if="invoice_origin == 'manual' && deleted_at == null" type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                </button>
                <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                    <i class="fp-back"> </i> Back
                </button>
                </template>
            </div>
            <div class="mobile-action-btn elipse-btn">
                <button v-if="invoice_origin == 'manual'" type="submit" id="editInvoiceBtn" v-on:click="editInvoice()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                </button>
                <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                    <i class="fp-back"> </i> Back
                </button>
                <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                    <i class="fp-ellipsis-v"></i>
                </button>
                <div id="myDropdown" class="dropdown-content">
                    <ul>
                        <li v-if="canAddCrm"><a  class="" href="javascript:void(0);" v-on:click="crmSection()" > CRM</a></li>
                        <li><a class="" v-on:click="previewInvoice()" > Print Or Preview</a></li>
                        <li><a  class="" v-on:click="downloadPdf()" > Download</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div id="workorder-detail work-order-view-top" class="admin-page-content permit-invoice-view">
                <template v-if="!isCrmSection">
                <section class="internal-container border-top-table-fl">
                    <template v-if="invoiceItemsArr == undefined || invoiceItemsArr.length == 0">
                        <div class="lineitem-main-section">
                        <h5>No Line Item Added</h5>
                        </div>
                    </template>
                    <template v-else>
                        <div class="table-responsive-sm">
                        <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="invoiceItemsArr != undefined && invoiceItemsArr.length > 0">
                            <thead>
                                <tr class="table-primary">
                                    <th>Unit Number</th>
                                    <th>GL Account</th>
                                    <th>Description</th>
                                    <th class="text-right">Permit Number</th>
                                    <th>Effective Date</th>
                                    <th>Expiry Date</th>
                                    <th class="text-right">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(invItems , itemKey) in invoiceItemsArr">
                                    <tr :key="'item1'+itemKey">
                                        <td>{{invItems.unit_no}}</td>
                                        <td>{{invItems.gl_account}}</td>
                                        <td>{{invItems.description}}</td>
                                        <td class="text-right">{{invItems.permit_number}}</td>
                                        <td> {{invItems.effective_date}} </td>
                                        <td> {{invItems.expiry_date}} </td>
                                        <td class="text-right"> {{invItems.amount}} </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        </div>
                    </template>
                    </section>
                    <section class="internal-container border-top-table-fl" v-if="paymentArr != undefined && paymentArr.length > 0">
                        <div class="journal-title">
                            <h5> Payment Detail </h5>
                        </div>
                        <template>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="paymentArr != undefined && paymentArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th># Document</th>
                                            <th class="text-right">Amount</th>
                                            <th>Date</th>
                                            <th>Posted By</th>
                                            <th>Processed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(pay , payKey) in paymentArr">
                                            <tr :key="'payment'+payKey">
                                                <td v-fp-html="pay.payment_no"></td>
                                                <td class="text-right">{{pay.amount}}</td>
                                                <td>{{pay.date}}</td>
                                                <td>{{pay.posted_by}}</td>
                                                <td>{{pay.payment_by}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Subtotal: </td>
                                            <td class="text-right"> {{total_before_tax}} </td>
                                        </tr>
                                        <tr>
                                            <td> Tax: </td>
                                            <td class="text-right discount-order-box">
                                            {{total_taxes}}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total: </td>
                                            <td class="order-total text-right"> {{total_due}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> <!--Description section-->
                    <!-- Journals -->
                    <section class="internal-container border-top-table-fl mt-4 loader-position">
                        <div :class="`loader-div${loaderClass}`" v-show="glLoading"></div>
                        <div class="journal-title">
                            <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i>   </h5>
                        </div>
                        <div :id="'demo'" class="accordian-body collapse show">
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1" >
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Account</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="journalsArr != undefined && journalsArr.length > 0">
                                        <template v-for="(journalItem , journalKey) in journalsArr">
                                            <tr :key="'journal'+journalKey">
                                                <template v-if="journalItem.account_description == 'Total'">
                                                    <td class="text-right">{{journalItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{journalItem.account_description}}</td>
                                                </template>
                                                <td class="text-right">{{journalItem.debit}}</td>
                                                <td class="text-right">{{journalItem.credit}}</td>
                                                <td class="text-right">{{journalItem.journal_amount}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4"><h5>No GL Found</h5></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                </template>
                <template v-else>
                    <!-- Invoice Crm -->
                    <div id="invoice-crm-list" class="admin-page-content invoice-view list-view">
                        <template v-if="crmAdd">
                            <crm-create :fromModule="invoiceObj"></crm-create>
                        </template>
                        <template v-else>
                            <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                            <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                <div class="bg-white data-table p-0">
                                    <invoice-crm-list v-if="enableInvoiceCrm" :moduleVal="'invoice'" :moduleId="invoiceId"></invoice-crm-list>
                                </div>
                            </section>
                        </template>
                    </div>
                </template>
                    </div>
                </div>
                <app-footer></app-footer>
            </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';
import CrmCreate from "@/components/CrmCreate.vue";
Vue.component("crm-create", CrmCreate);

Vue.component("permit-activity-log-list", ActivityLogListView);


export default {
    name: "PermitInvoiceView",
    components: {
        invoiceCrmList: () => import('@/components/CrmList.vue')
    },
    mixins:[commonMixins],
    data: () => ({
        invoiceArr:[],
        invoiceItemsArr:[],
        loading:false,
        glLoading:false,
        invoiceId : 0,
        invoice_number:'',
        deleted_at:'',
        invoice_date:'',
        company:'',
        user_number:'',
        customer:'',
        total_before_tax:'',
        total_taxes:'',
        total_due:'',
        activityLogsTabValue: "invoiceloadList",
        activetab:1,
        invoice_origin:"system",
        journalsArr:[],
        isCrmSection:false,
        enableInvoiceCrm:false,
        canAddCrm:false,
        crmAdd:false,
        invoiceObj:{},
        permissions:[],
        cantAccessPage:"",
        crmBtnTitle:"CRM",
        paymentArr:[],
        invType:"",
        status:"",
        dueDate:"",
        term:"",
        created_at:'',
        open_amount:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_invoice') {
                    self.cantAccessPage = true;
                }
                if (permissions.name == 'add_crm') {
                    self.canAddCrm = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    beforeDestroy(){
        this.$root.$off('invoice_system');
    },
    mounted: function() {
        var self = this;
        // self.$root.$on("invoice_system_permit",(invoiceId)=>{
        //     self.invoiceId = invoiceId;
        //     // self.getPermissions();
        //     self.loadInvoiceData();
        // });
        self.invoiceId = this.$route.params.id.toString();
        //set value in invoice object for crm
        self.invoiceObj.module = "invoice";
        self.invoiceObj.invoice_id = this.$route.params.id;
        self.invoiceObj.flag = "add";
        self.invoiceObj.crm_id = "";
        self.getPermissions();
        self.loadInvoiceData();
    },
    metaInfo() {
        return {
            title: (this.invoice_number != "") ? this.invoice_number + " | Customer Invoice View | " +process.env.COPYRIGHT_NAME:"Customer Invoice View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        loadInvoiceData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice-permit/view",
                // url: process.env.ROOT_API + "/permit-invoice/preview",
                type: "GET",
                crossDomain: true,
                headers: this.ajxHeaders,
                data:{invoice_id:self.invoiceId},
                dataType: "json",
                success: function(data) {
                    self.loading = false;

                    console.log(data.content)
                    if (data.status == "success") {
                        // if (data.content.length > 0) {
                            self.invoiceObj.customer_id = data.content.customer_id;
                            self.invoiceObj.vehicle_id = data.content.vehicle_id;
                            self.invoiceArr = data.content;
                            self.invoice_number = data.content.invoice_number;
                            self.deleted_at = data.content.deleted_at;
                            self.invoice_date = data.content.invoice_date;
                            self.company = data.content.company;
                            self.user_number = data.content.user_number;
                            self.customer = data.content.customer;
                            self.total_before_tax = data.content.sub_total;
                            self.total_taxes = data.content.tax_amount;
                            self.total_due = data.content.total;
                            self.invoice_origin = data.content.origin;
                            self.dueDate = data.content.due_date;
                            self.invType = data.content.invoice_type_name;
                            self.status = data.content.status;
                            self.term = data.content.term_name;
                            self.created_at = data.content.created_at;
                            self.open_amount = data.content.open_amount;
                            if (data.content.items != undefined) {
                                self.invoiceItemsArr = data.content.items;
                            }else{
                                self.invoiceItemsArr = [];
                            }
                            // if (data.content.journals != undefined) {
                            //     self.journalsArr = data.content.journals;
                            // }else{
                            //     self.journalsArr = [];
                            // }
                            self.paymentArr = data.content.payment;
                            self.getGLEntry(data.content.invoice_number);
                        // }
                        console.log(self.invoiceArr);

                    }
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'permit-invoice-preview');
                }
            });
        },
        getGLEntry(invNo) {

            var self = this;
            self.glLoading = true;
            $.ajax({
                url: process.env.ROOT_API + "/module/gl",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{'id':self.invoiceId,'doc_no':invNo,'name':'customer invoice'},
                success: function (data) {
                    self.glLoading = false;
                    if (data.status == "success") {
                        self.journalsArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.glLoading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'workorder-invoice-view');
                }
            });
        },
        activityLogs(){

          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");

          self.$root.$emit('activity_log_opted','asset permit',segments[3]);
          self.activityLogsTabValue = "invoiceloadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
        downloadPdf(){
            var self = this;

            self.loading = true ;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/pdf",
                type: "POST",
                data: {
                    invoice_id:self.invoiceId,
                    invoice_type:'PE',
                    invoice_origin:'system'
                },
                headers: this.ajxHeaders,
                dataType: 'json',
                success: function (data) {
                    self.loading = false ;
                    if (data.status == 'success'){
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data.content;
                        link.download = '';
                        link.target = "_blank";
                        link.click();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'permit-invoice-pdf');
                }
            });

        },
        // previewInvoice(flag) {
        //     var self = this;
        //     self.loading = true;
        //     $.ajax({
        //         // url: process.env.ROOT_API + "/invoice-permit/view",
        //         url: process.env.ROOT_API + "/permit-invoice/preview",
        //         type: "GET",
        //         crossDomain: true,
        //         headers: {
        //             'Accept': 'application/json',
        //             "Authorization": "Bearer "+localStorage.getItem("tkn"),
        //             'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
        //             "Cache-Control": "no-cache"
        //         },
        //         data:{invoice_id:self.invoiceId,from:'preview'},
        //         dataType: "html",
        //         success: function(data) {
        //             self.loading = true;
        //             var content = data;

        //             setTimeout(function(){
        //                 var a = window.open(data, '_blank');
        //                 a.document.write(content);
        //                 a.document.close();
        //                 self.loading = false;
        //                 a.print();
        //                 a.close();
        //             },1000);

        //         },
        //         error: function(jqXHR, exception) {
        //             self.loading = false;
        //             if (jqXHR.status == 0) {
        //                 self.error = "Remote server cannot be reached";
        //             } else
        //             if (jqXHR.status == 401) {
        //                 //clear previous data
        //                 localStorage.removeItem('user_obj');
        //                 localStorage.removeItem('api_token');
        //                 self.$router.push("/");
        //             }
        //             if (jqXHR.status == 403) {
        //                 //clear previous data
        //                 self.$router.push("/");

        //             }
        //             else {
        //                 self.error = jqXHR.responseJSON.message;
        //             }
        //         }
        //     });
        // },
        previewInvoice() {
            var self = this;

            self.$router.push("/invoice/permit/preview/" + self.invoiceId);

        },
        backBtn: function(){
            var self = this;
            var webloc = window.location.href;
            var url_check = new URL(webloc);
            var from = url_check.searchParams.get("from");

            if (from != undefined && from == "permit") {
                self.$router.push('/vehiclepermit/list');
            }else if(from != undefined && from == "gl"){
                self.$router.push('/report/general-ledger');
            }else{
              var url = "";
              var fromUrl = url_check.searchParams.get("fromUrl");
              if ( fromUrl != undefined ) {
                if(from == 'customer'){
                  var  selectTab = '?viewTab=invoice';
                  url = atob(fromUrl)+selectTab;
                }else{
                  url = atob(fromUrl);
                }
              }else{
                  url = '/invoice/list'
              }

              self.redirectPageUrl(url);
            }
        },
        editInvoice() {
            var self = this;
            self.$router.push("/invoice/permit/edit/" + self.invoiceId);
        },
        crmSection() {
            var self = this;
            if (!self.isCrmSection) {
                self.isCrmSection = true;
                self.enableInvoiceCrm = true;
                self.crmBtnTitle = "Detail";
            }else{
                self.isCrmSection = false;
                self.enableInvoiceCrm = false;
                self.crmAdd = false;
                self.crmBtnTitle = "CRM";
            }
        },
        addCrm() {
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = "";
            self.invoiceObj.flag = "add";
        },
        cancelCrmFromView() {
            var self = this;
            self.crmAdd = false;
        },
        editCrmFromView(crmId){
            var self = this;
            self.crmAdd = true;
            self.invoiceObj.crm_id = crmId;
            self.invoiceObj.flag = "update";
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/PermitInvoice.vue